import * as React from 'react';
import { trackEvent, trackPageView } from './elog/mparticle_tracker';
import { MParticleEvent, PageViewEvent } from './elog/mparticle_types';

export function useViewTracking(
  viewEvent: MParticleEvent,
  shouldTrack: boolean,
) {
  const [hasViewed, setView] = React.useState(false);

  React.useEffect(() => {
    if (!shouldTrack || hasViewed) return;

    trackEvent(viewEvent);

    setView(true);
  }, [hasViewed, shouldTrack, viewEvent]);

  return [hasViewed, setView];
}

export function usePageViewTracking(mParticlePageView: PageViewEvent, triggerEffectProps) {
  React.useEffect(() => {
    if (!mParticlePageView) { return; }

    trackPageView(mParticlePageView);
  }, [mParticlePageView, triggerEffectProps]);
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/use_tracking.tsx